export type PhotoIdentifier =
  | 'MBL'
  | 'HBL'
  | 'AIR_MBL'
  | 'AIR_HBL'
  | 'ON_HAND'
  | 'IMPORT_LOAD_GUIDE'
  | 'EXPORT_LOAD_GUIDE'
  | 'INTERFACILITY_LOAD_GUIDE';

export const PhotoIdentifiers: Record<PhotoIdentifier, PhotoIdentifier> = {
  MBL: 'MBL',
  HBL: 'HBL',
  AIR_MBL: 'AIR_MBL',
  AIR_HBL: 'AIR_HBL',
  ON_HAND: 'ON_HAND',
  IMPORT_LOAD_GUIDE: 'IMPORT_LOAD_GUIDE',
  EXPORT_LOAD_GUIDE: 'EXPORT_LOAD_GUIDE',
  INTERFACILITY_LOAD_GUIDE: 'INTERFACILITY_LOAD_GUIDE',
} as const;
